import { FC } from 'react'
import { TimeEntryModeProvider } from '../../useTimeEntryMode'
import { AvailabilityProvider } from './Availability'

const Providers: FC = ({ children }) => (
  <AvailabilityProvider>
    <TimeEntryModeProvider>{children}</TimeEntryModeProvider>
  </AvailabilityProvider>
)

export { Providers }
